import { useState } from "react";
import { toast } from "sonner";
import { FileCheck2, CircleCheck, CircleAlert, Download } from "lucide-react";
import { api, errMsg, download } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const Errori = ({ list }) => (
  <div className="min-w-0 space-y-2" data-testid="xml-errors">
    <p className="flex items-center gap-2 font-semibold text-rose-700"><CircleAlert className="h-5 w-5" />File bloccato: {list.length} errori rispetto allo schema ufficiale. Correggi la fattura e riprova.</p>
    <ul className="max-h-[50vh] space-y-1 overflow-y-auto text-sm">
      {list.map((e, n) => <li key={n} className="rounded border border-rose-200 bg-rose-50 p-2"><b>{e.campo}</b>{e.valore && <span className="font-mono"> «{e.valore}»</span>}<br /><span className="text-xs text-rose-800">{e.errore}</span></li>)}
    </ul>
  </div>
);

const Ok = ({ res, id }) => (
  <div className="min-w-0 space-y-3" data-testid="xml-ok">
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-3">
      <p className="flex min-w-0 items-center gap-2 break-all font-semibold text-emerald-800"><CircleCheck className="h-5 w-5" />Controllo superato: nessun errore ({res.schema}) · {res.filename}</p>
      <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="xml-official-download" onClick={() => download(`/invoices/${id}/xml-ufficiale`).catch((e) => toast.error(e.message))}><Download className="mr-2 h-4 w-4" />Scarica file XML</Button>
    </div>
    <pre className="max-h-[60vh] overflow-auto rounded-lg bg-slate-900 p-4 text-xs leading-relaxed text-emerald-100" data-testid="xml-content">{res.xml}</pre>
  </div>
);

export const XmlUfficiale = ({ id, trigger }) => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const crea = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/invoices/${id}/xml-ufficiale`); setRes({ ok: true, ...data }); } catch (e) {
      const d = e?.response?.data?.detail;
      if (d?.errori) setRes({ ok: false, errori: d.errori }); else toast.error(errMsg(e));
    } finally { setBusy(false); }
  };
  return (
    <>
      {trigger ? trigger(crea, busy) : <Button variant="outline" className="bg-white" disabled={busy} data-testid="xml-official-button" onClick={crea}><FileCheck2 className="mr-2 h-4 w-4" />{busy ? "Controllo…" : "XML ufficiale"}</Button>}
      <Dialog open={!!res} onOpenChange={(o) => !o && setRes(null)}>
        <DialogContent className="w-[95vw] max-w-5xl" data-testid="xml-official-dialog">
          <DialogHeader><DialogTitle>File XML ufficiale FatturaPA</DialogTitle></DialogHeader>
          {res && (res.ok ? <Ok res={res} id={id} /> : <Errori list={res.errori} />)}
        </DialogContent>
      </Dialog>
    </>
  );
};
